<template>
    <el-dialog :visible.sync="dialogVisible" width="885px" custom-class="personal-dialog" @close="handleClose"
    	:show-close="false" center :close-on-click-modal="false" destroy-on-close  append-to-body>
		<div class="personal">
			<div class="closebtn cur" @click="dialogVisible=false">
				<i class="el-icon-close"></i>
			</div>
			<div class="title">
				<div class="t1">完善个人信息</div>
				<div class="t2">根据环太湖动产登记备案综合服务平台相关要求，您需要进一步完善个人基本信息，平台认证通过后，可以正常进行作品备案登记。</div>
			</div>
			<div class="personal-form">
				<personalForm @personal="personal"></personalForm>
			</div>
		</div>
	</el-dialog>
</template>

<script>
import util from "@/common/util.js";
import personalForm from "./form.vue"
export default {
    name: 'personal',
	components:{
		personalForm
	},
    props: {
        // 外部参数示例
        // data: {
        //     type: Array,
        //     default: () => []
        // },
    },
    data() {
        return {
            // 内部参数
			dialogVisible:false,
        }
    },
    methods: {
		handleClose(){
			
		},
		personal(){
			this.dialogVisible = false
		}
    },
    mounted() {

    }

}
</script>

<style lang="scss">
	@import "personal.scss";
</style>